/** Mock data for the Confirm info cards prototype — every card shown fully populated. */

import { CoverageType } from '@/models/insuranceCoverage'

export const BUSINESS_DETAILS = [
  { label: 'DOT number', value: '3300318' },
  { label: 'Company name', value: 'Test Mock Trucking LLC' },
  { label: 'Business type', value: 'Corporation/LLC' },
  { label: 'Address', value: '4820 W Grand Ave, Chicago, IL 60639' },
  { label: 'Years in business', value: '8 years' },
  { label: 'ELD provider', value: 'Motive' },
]

export const COVERAGE_NEEDS = {
  startsOn: 'Oct 1, 2026',
  coverages: [CoverageType.AUTO_LIABILITY, CoverageType.AUTO_PHYSICAL_DAMAGE, CoverageType.MOTOR_TRUCK_CARGO],
}

export const OWNER_INFO = [
  { label: 'Owner name', value: 'Harold Lynn Shirk' },
  { label: 'Email', value: 'jamiehartman@rigidply.com' },
  { label: 'Phone number', value: '(555) 302-1611' },
  { label: 'Date of birth', value: 'Jan 15, 1985' },
  { label: 'Marital status', value: 'Single' },
]

export const DRIVING_DISTANCE = ['Regional (51-150 miles)']

export const FREIGHT_TYPES = [
  { name: 'General freight', percentage: 60 },
  { name: 'Building materials', percentage: 30 },
  { name: 'Machinery, large objects', percentage: 10 },
]

export const CLAIMS_STATE_COPY: Record<string, { body: string[]; footer?: string }> = {
  parsed: {
    body: ['7 loss runs added'],
    footer: 'Have more loss run reports? You can provide them after submitting your application.',
  },
  clean: { body: ['0 losses (clean loss run report on file)'] },
  single: {
    body: ['1 loss run added'],
    footer: 'Have more loss run reports? You can provide them after submitting your application.',
  },
  skipped: {
    body: ['Loss run reports not yet provided.'],
    footer: 'Insurance providers will require these before checkout.',
  },
  parsing: {
    body: ['Updating your application with loss run info.', 'This may take a few minutes...'],
  },
}
